<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增节点</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #write="{ row }">
        <div>
        {{row.is_writable ? '读写' : '只读'}}
        </div>
      </template>
      <template #data_type="{ row }">
        <div>
          {{ getNameByValue(dataType, row.data_type) }}
        </div>
      </template>

      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openEdit(row)"
            >编辑</el-button
          >
           <el-button type="danger" size="small" @click="del(row)"
            >删除</el-button
          >
        </div>
      </template>
    </auto-table>

    <addNode ref="editRef" @success="getList(1)"></addNode>
  </div>
</template>

<script>
import addNode from "./addNode.vue";
import {
  dataType
} from "@/views/deviceManage/components/dict";
export default {
  components: {
    addNode,
  },
  props: {
    device: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
        dataType,
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "从机地址", value: "slave_id" },
        { name: "寄存器地址", value: "address" },
        { name: "数据类型", value: "data_type", type: "custom" },
         { name: "读写类型", value: "write", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
    };
  },

  mounted() {
    
  },
  methods: {
    openEdit(row) {
      this.$refs.editRef.open(row,this.device);
    },
    openAdd() {
      this.$refs.editRef.open({},this.device);
    },
    init() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    //获取列表
    getList(v) {
      if (!this.device.id) {
        return;
      }
      let page = v || 1;
      this.$axios({
        url: "/device/deviceNode/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          device_id: this.device.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    del(row){
        this.$confirm('确定删除子节点').then(res=>{
            this.$post("/device/deviceNode/delete",{id:row.id}).then(res=>{
                this.getList(1);
            })
        })
    }
  },
};
</script>

<style lang="less" scoped>
</style>